// Preview cart actions stay local. The advice button opens the existing Podium widget; it never sends a message.
export const isLocalHost = host => /^(localhost|127(?:\.\d{1,3}){3}|\[?::1\]?)$/.test(host);
export function money(cents,currency='AUD',locale='en-AU') {
  if(!Number.isSafeInteger(cents)) throw new TypeError('Price must be integer minor units');
  return new Intl.NumberFormat(locale,{style:'currency',currency,minimumFractionDigits:cents%100?2:0,maximumFractionDigits:2}).format(cents/100);
}
export function addLine(lines,item) {
  if(!item.id||!Number.isSafeInteger(item.price)||item.price<0) throw new TypeError('Invalid selection');
  const next=lines.map(line=>({...line}));
  const match=next.find(line=>line.id===item.id);
  if(match)match.quantity+=1;else next.push({...item,quantity:1});
  return next;
}
export const subtotal = lines => lines.reduce((sum,line)=>sum+line.price*line.quantity,0);
const controllers=new WeakMap();
function mount(root) {
  if(controllers.has(root)) { controllers.get(root).refresh(); return; }
  root.dataset.vrEnhanced='true';
  let lines=[],previousFocus=null,previousOverflow='',activeDialog=null;
  const selected=new Set();
  const locale=document.documentElement.lang||'en-AU';
  const announce=text=>{const node=root.querySelector('[data-vr-announcement]');if(node)node.textContent=text;};
  const element=(tag,text,className)=>{const node=document.createElement(tag);if(text!==undefined)node.textContent=text;if(className)node.className=className;return node;};
  function release(dialog) {
    if(!dialog||dialog!==activeDialog)return;
    document.body.style.overflow=previousOverflow;
    activeDialog=null;
    if(previousFocus?.isConnected)previousFocus.focus();
  }
  function close(dialog) {
    if(dialog?.open)dialog.close();
    // Native close events are queued. Restore scrolling before opening another dialog.
    release(dialog);
  }
  function open(dialog,trigger) {
    if(!dialog)return;
    if(activeDialog?.open)close(activeDialog);
    previousFocus=trigger||document.activeElement;
    previousOverflow=document.body.style.overflow;
    activeDialog=dialog;dialog.showModal();document.body.style.overflow='hidden';
  }
  function choice(dialog) {
    const radio=dialog.querySelector('input[type=radio]:checked');
    const option=radio?.closest('[data-vr-option]');
    const variant=option?.querySelector('[data-vr-variant]');
    const selectedVariant=variant?.selectedOptions[0];
    const price=Number(selectedVariant?.dataset.price);
    if(!radio||radio.disabled||!selectedVariant?.value||selectedVariant.disabled||selectedVariant.dataset.available!=='true'||!Number.isSafeInteger(price)||price<0)return null;
    return {id:selectedVariant.value,price,name:option.dataset.title+(selectedVariant.dataset.name==='Default Title'?'':' — '+selectedVariant.dataset.name),url:option.dataset.url,productId:option.dataset.productId};
  }
  function update(dialog) {
    const item=choice(dialog),preview=dialog.dataset.preview!=='false'||isLocalHost(location.hostname);
    const button=dialog.querySelector('[data-vr-submit]');
    button.disabled=!item;button.textContent=preview?'Add to preview cart':'Add to cart';
    const field=dialog.querySelector('[data-vr-variant-id]');field.disabled=!item;field.value=item?.id||'';
    dialog.querySelector('[data-vr-total]').textContent=item?money(item.price,dialog.dataset.currency,locale):'Choose an available option';
    const first=dialog.querySelector('[data-vr-option]');
    const difference=item?item.price-Number(dialog.dataset.basePrice):0;
    dialog.querySelector('[data-vr-increment]').textContent=item&&item.productId!==first.dataset.productId&&dialog.dataset.baseVaries!=='true'?(difference>=0?'+':'−')+money(Math.abs(difference),dialog.dataset.currency,locale)+' compared with the rack alone.':'';
    dialog.querySelectorAll('[data-vr-option]').forEach(option=>{
      const active=option.querySelector('input[type=radio]').checked;
      const select=option.querySelector('[data-vr-variant]');select.disabled=!active;
    });
    if(preview) {
      dialog.querySelector('form').removeAttribute('action');
      dialog.querySelector('[data-vr-mode-note]').textContent='Local preview only. No order is placed. Freight and any installation are additional; confirm the final charges.';
    }
  }
  function drawCart(trigger) {
    const dialog=root.querySelector('[data-vr-cart]');if(!dialog)return;
    const target=dialog.querySelector('[data-vr-cart-items]');target.replaceChildren();
    if(!lines.length)target.append(element('p','Your preview cart is empty. Choose a rack and explore your setup.'));
    for(const line of lines) {
      const row=element('article',undefined,'vr-cart-item');
      row.append(element('h3',line.name),element('p','Quantity '+line.quantity+' · '+money(line.price*line.quantity,root.querySelector('[data-vr-main]').dataset.currency,locale)));
      const remove=element('button','Remove','vr-text-button');remove.type='button';remove.dataset.vrRemove=line.id;row.append(remove);target.append(row);
    }
    dialog.querySelector('[data-vr-cart-total]').textContent=money(subtotal(lines),root.querySelector('[data-vr-main]').dataset.currency,locale);
    if(!dialog.open)open(dialog,trigger);
  }
  function compareTray() {
    const tray=root.querySelector('[data-vr-tray]');if(!tray)return;
    tray.hidden=!selected.size;tray.querySelector('[data-vr-compare-count]').textContent=selected.size+' selected';
    tray.querySelector('[data-vr-show-comparison]').disabled=selected.size<2;
  }
  function showComparison(trigger) {
    if(selected.size<2)return;
    const dialog=root.querySelector('[data-vr-comparison]'),container=dialog.querySelector('[data-vr-comparison-content]');
    const table=element('table'),head=element('thead'),headRow=element('tr');
    const first=element('th','Your decision');first.scope='col';headRow.append(first);
    const rows=['Rack-only price','Best suited to','Overall rack height','Upright steel','Included equipment'].map(label=>{const row=element('tr');const cell=element('th',label);cell.scope='row';row.append(cell);return row;});
    for(const id of selected) {
      const card=Array.from(root.querySelectorAll('[data-vr-card]')).find(card=>card.dataset.vrCard===id);
      const fragment=card.querySelector('template').content;
      headRow.append(fragment.querySelector('th').cloneNode(true));
      fragment.querySelectorAll('td').forEach((cell,i)=>rows[i].append(cell.cloneNode(true)));
    }
    head.append(headRow);const body=element('tbody');rows.forEach(row=>body.append(row));table.append(head,body);container.replaceChildren(table);open(dialog,trigger);
  }
  root.addEventListener('click',event=>{
    const advice=event.target.closest('[data-vr-podium]');
    if(advice){
      const status=advice.closest('#vr-help').querySelector('[data-vr-chat-status]');
      status.hidden=true;status.textContent='';
      if(isLocalHost(location.hostname)){
        status.textContent='Chat is available in the Shopify preview. You can also call the number above for rack advice.';
        status.hidden=false;return;
      }
      try{
        if(typeof window.PodiumWebChat?.open!=='function')throw new Error('Chat unavailable');
        window.PodiumWebChat.open();
      }catch{
        status.textContent='Chat couldn’t open. Please try again in a moment, or call the number above.';
        status.hidden=false;
      }
      return;
    }
    const filterToggle=event.target.closest('[data-vr-filter-toggle]');
    if(filterToggle){const form=filterToggle.closest('form'),fields=form.querySelector('.vr-filter-fields'),show=fields.dataset.open!=='true';fields.dataset.open=String(show);form.querySelectorAll('[data-vr-filter-toggle]').forEach(button=>button.setAttribute('aria-expanded',String(show)));if(show)(filterToggle.dataset.vrFilterToggle==='sort'?fields.querySelector('select'):fields.querySelector('summary'))?.focus();return;}
    const trigger=event.target.closest('[data-vr-open]');
    if(trigger) {
      const dialog=document.getElementById(trigger.dataset.vrOpen);
      if(!dialog||!root.contains(dialog))return;
      event.preventDefault();update(dialog);open(dialog,trigger);return;
    }
    const closer=event.target.closest('[data-vr-close]');if(closer){close(closer.closest('dialog'));return;}
    if(event.target.closest('[data-vr-show-comparison]'))showComparison(event.target.closest('button'));
    if(event.target.closest('[data-vr-clear-comparison]')){selected.clear();root.querySelectorAll('[data-vr-compare]').forEach(input=>input.checked=false);compareTray();}
    if(event.target.closest('[data-vr-compare-help]')){announce('Tick Compare beneath up to three racks.');root.querySelector('[data-vr-compare]')?.focus();}
    const remove=event.target.closest('[data-vr-remove]');if(remove){lines=lines.filter(line=>line.id!==remove.dataset.vrRemove);drawCart();root.querySelector('[data-vr-cart] button')?.focus();}
  });
  root.addEventListener('change',event=>{
    const dialog=event.target.closest('[data-vr-setup]');if(dialog)update(dialog);
    if(event.target.matches('[data-vr-compare]')) {
      const input=event.target;
      if(input.checked&&selected.size>=3){input.checked=false;announce('Compare up to three racks at a time.');return;}
      if(input.checked)selected.add(input.dataset.vrCompare);else selected.delete(input.dataset.vrCompare);compareTray();
    }
  });
  root.addEventListener('submit',event=>{
    const form=event.target.closest('[data-vr-form]');if(!form)return;
    const dialog=form.closest('[data-vr-setup]'),item=choice(dialog);
    if(!item){event.preventDefault();dialog.querySelector('[data-vr-status]').textContent='Choose an available option before continuing.';return;}
    const preview=dialog.dataset.preview!=='false'||isLocalHost(location.hostname);
    if(preview){event.preventDefault();lines=addLine(lines,item);const trigger=previousFocus;close(dialog);drawCart(trigger);}
    // With separately enabled live mode, Shopify's native form submits one exact variant.
  });
  root.addEventListener('close',event=>{if(!event.target.open)release(event.target);},true);
  document.querySelectorAll('[data-vr-external-cart]').forEach(button=>button.addEventListener('click',()=>drawCart(button)));
  const refresh=()=>{selected.clear();root.querySelectorAll('[data-vr-compare]').forEach(input=>input.checked=false);compareTray();if(activeDialog&&!activeDialog.isConnected)release(activeDialog);};
  controllers.set(root,{refresh});
}
if(typeof document!=='undefined') {
  document.querySelectorAll('.vr').forEach(mount);
  document.addEventListener('shopify:section:load',event=>{const root=event.target.closest('.vr');if(root)mount(root);});
  document.addEventListener('shopify:section:unload',event=>{const root=event.target.closest('.vr');if(root)controllers.get(root)?.refresh();});
}
